export default {
	confirmed: 1,
	approved: 2,
	shipped: 3,
	delivered: 4
}